<template>
  <Modal
    v-model="visible"
    title="批量添加意图词"
    :width="width"
    :mask-closable="false"
    class-name="betch-import"
    @on-visible-change="bindGetData"
  >
    <span>每行一个意图词（通过回车换行），每个意图词不得超过40字节（汉字占2个字节），支持黏贴多行文本添加意图词</span>
    <Input
      v-model="labels"
      type="textarea"
      style="width: 100%; margin: 4px 0"
      :autosize="{ minRows: 8, maxRows: 9 }"
      placeholder="每行一个意图词（通过回车换行），每个意图词不得超过40字节（汉字占2个字节），支持黏贴多行文本添加意图词"
    />
    <p>
      <span
        >已输入意图词<span :class="{ 'g-error-text': rows > length }">{{ rows }}</span
        >/<span>{{ length }}</span></span
      >
    </p>

    <template slot="footer">
      <Button type="default" size="small" @click="$emit('input', false)">取消</Button>
      <Button type="primary" size="small" @click="ok">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { isArray, isEmpty, trim, getByteLen } from '@/common/js/utils'

export default {
  name: 'betchImport',
  props: {
    value: {
      type: Boolean
    },
    max: {
      type: [Number, String]
    },
    result: {
      type: Array,
      require: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$set('input', val)
      }
    },
    len() {
      return this.result.length
    },
    length() {
      return this.max - this.len
    },
    rows() {
      return isEmpty(this.labels) ? 0 : this.labels.split(/\r?\n/).filter((ret) => trim(ret)).length
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.labels = ''
      }
    },
    async ok() {
      const tags = this.labels
        .split(/\r?\n/)
        .map((ret) => trim(ret))
        .filter((ret) => !isEmpty(ret))
      // 验证
      if (isArray(tags) && tags.length > this.length) {
        this.$Message.error(`输入的意图词数超过了最大数${this.length}`)
        return
      } else if (isArray(tags) && !tags.length) {
        this.$Message.error('输入的意图词数不能为空！')
        return
      } else if (!isArray(tags)) {
        this.$Message.error('输入的意图词数不合法！')
        return
      }
      const vaildTags = tags.filter((ret, id) => {
        const idx = tags.findIndex((met) => met === ret)
        const include = this.result.findIndex((met) => met === ret) > -1
        const strLen = getByteLen(ret)
        return idx === id && strLen <= 40 && !include
      })
      const failTags = tags.filter((ret, id) => {
        const idx = tags.findIndex((met) => met === ret)
        const include = this.result.findIndex((met) => met === ret) > -1
        const strLen = getByteLen(ret)
        return idx !== id || strLen > 40 || include
      })
      if (isArray(failTags) && failTags.length) {
        // 去重
        this.$Modal.info({
          title: '系统消息',
          width: this.width,
          content: `<span>批量导入有效意图词 <span style="color: #19be6b">${
            vaildTags.length
          }</span>  个，无效  <span style="color: #ed4014"> ${tags.length - vaildTags.length} </span>  个 </span> </p>`,
          onOk: () => {
            this.$emit('on-select', vaildTags)
          }
        })
      } else {
        this.$emit('on-select', vaildTags)
      }
    }
  },
  data() {
    return {
      labels: '',
      width: 720
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .betch-import {
  span {
    line-height: 26px;
  }

  .ivu-modal-body {
    padding: 6px 15px;
  }
}
</style>
